import React from 'react'
import { Button } from '@mui/material'
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'

import {
  useDownloadJournalReconReportCsvLazyQuery
} from '../../../../api-services/financial/journalReconApi'
import { type JournalReconReportMeta } from '../../../../api-schema-types/financial/JournalReconDomainDtos'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import ButtonLoadingComponent from '../../../../views/components/shared/ButtonLoadingComponent'

interface Props {
  startDate: string
  report: JournalReconReportMeta
  disabled: boolean
}

const DownloadJournalReconReportButton: React.FC<Props> = ({ startDate, report, disabled }) => {
  const dispatch = useAppDispatch()
  const [trigger, { isFetching }] = useDownloadJournalReconReportCsvLazyQuery()

  const handleDownload = (): void => {
    trigger({ startDate, reportName: report.slug })
      .unwrap()
      .then((result) => {
        const blob = new Blob([result.csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = result.filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <Button
      variant={'outlined'}
      color={'primary'}
      fullWidth
      disabled={disabled || isFetching}
      startIcon={<DownloadOutlinedIcon />}
      onClick={handleDownload}
      sx={{ justifyContent: 'flex-start', textTransform: 'none' }}
    >
      {report.filePrefix}-{report.baseFilename}
      { isFetching && <ButtonLoadingComponent /> }
    </Button>
  )
}

export default DownloadJournalReconReportButton
